// Module
var code = "<p class=copyright>Grégory Albouy © 2020</p>";
// Exports
export default code;